import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VChip,
    {
      staticClass: "my-2",
      class: _vm.item.isActive ? "pr-1" : undefined,
      attrs: {
        color: _vm.item.isActive ? "primary" : "bg-primary",
        "text-color": _vm.item.isActive ? "bg-gray-0" : "primary",
      },
      on: {
        click: function ($event) {
          _vm.onClick($event, () => _vm.item.onClick(_vm.item))
        },
      },
    },
    [
      _c(
        "div",
        {
          class: { "text-truncate": _vm.item.truncate },
          style: _vm.item.truncate ? { maxWidth: `200px` } : undefined,
        },
        [_vm._v("\n    " + _vm._s(_vm.item?.name) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.item.dropdown
        ? _c(VIcon, { attrs: { right: "", size: "18" } }, [
            _vm._v("\n    ui-icon-arrow-down\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.isActive
        ? _c(
            VBtn,
            {
              staticClass: "ml-1",
              attrs: {
                icon: "",
                text: "",
                light: "",
                small: "",
                color: "bg-gray-0",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.onClick($event, () => _vm.item.onReset(_vm.item))
                },
              },
            },
            [
              _c(VIcon, { attrs: { size: "18", light: "" } }, [
                _vm._v("\n      ui-icon-close-circle\n    "),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }